/**
 * @file Metrics 有关的枚举值
 */
// 子事件属性映射
export const EVENT_ATTRIBUTE_SKAN = {
  UNIQUE_EVENT: {
    value: 1,
    i18n: 'common_unique_event',
  },
  UNIQUE_CPA: {
    value: 2,
    i18n: 'common_unique_cost',
  },
  UNIQUE_CONVERSION_RATE: {
    value: 3,
    i18n: 'common_unique_rate',
  },
  TOTAL_EVENTS: {
    value: 4,
    i18n: 'common_total_event',
  },
  TOTAL_CPA: {
    value: 5,
    i18n: 'common_CPA',
  },
  TOTAL_CONVERSION_RATE: {
    value: 6,
    i18n: 'common_total_value',
  },
};
export const EVENT_ATTRIBUTE = {
  EVENT_COUNT: { // 事件发生的次数
    value: 1,
    i18n: 'common_event_total_count',
  },
  COST_PER_EVENT: { // 单次事件的付费成本
    value: 2,
    i18n: 'common_Cost',
  },
  RATE_PER_EVENT: { // 平均每个用户执行某事件的概率/次数
    value: 3,
    i18n: 'common_rate',
  },
  VALUE_PER_EVENT: { // 每个Event的平均价值
    value: 4,
    i18n: 'common_value_per_event',
  },
  TOTAL_EVENT_VALUE: { // 总付费价值
    value: 5,
    i18n: 'common_total_value',
  },
};
export const EVENT_ATTRIBUTE_EACH = {
  EVENT_COUNT: { // 事件发生的次数
    value: 1,
    i18n: 'common_total_event',
  },
  COST_PER_EVENT: { // 单次事件的付费成本
    value: 2,
    i18n: 'common_CPA',
  },
  VALUE_PER_EVENT: { // 每个Event的平均价值
    value: 3,
    i18n: 'common_value_per_event',
  },
  TOTAL_EVENT_VALUE: { // 总付费价值
    value: 4,
    i18n: 'common_total_value',
  },
};
export const EVENT_ATTRIBUTE_UNIQUE = {
  EVENT_COUNT: { // 事件发生的次数
    value: 1,
    i18n: 'common_unique_event',
  },
  COST_PER_EVENT: { // 单次事件的付费成本
    value: 2,
    i18n: 'common_unique_cost',
  },
  RATE_PER_EVENT: { // 平均每个用户执行某事件的概率/次数
    value: 3,
    i18n: 'common_unique_rate',
  },
};

// 指标类型
export const METRIC_TYPE = {
  BASIC_DATA: 0,
  VIDEO_PLAY: 1,
  APP_EVENT: 2,
  ATTRIBUTION: 3,
  PAGE_EVENT: 4,
  APP_EVENT_EACH: 5, // app event下的子tab - each
  APP_EVENT_UNIQUE: 6, // app event下的子tab - unique
  INTERACTION: 7,
  // 新增指标 engagement
  ENGAGEMENT: 8,
  // skan 相关的指标
  SKAN_APP_EVENT: 9,
  // https://bytedance.feishu.cn/wiki/wikcnlF7RQtO87J8xLfcyAQtVTb#
  SETTINGS_NAMES_IDS: 10,
  SETTINGS_STATUS_DATES: 11,
  SETTINGS_OBJECTIVE_BUDGET_GOAL: 12,
  SETTINGS_AD_CREATIVE: 13,
  SETTINGS_OTHER: 14,

  // 素材库新增类型
  LIBRARY_CREATIVE_INFO: 20,
  // LIBRARY_CREATIVE_BASE_INFO: 21,
  LIBRARY_CREATIVE_DATE_INFO: 22,
  LIBRARY_CREATIVE_DETAILS_INFO: 23,
  LIBRARY_CREATIVE_RELATED_INFO: 24,
  LIVE: 25,
  ASSET: 26,
  ONSITE_EVENT: 27,
};

export const METRIC_TYPE_EVENT_ATTRIBUTES_MAP = {
  [METRIC_TYPE.APP_EVENT_EACH]: Object.values(EVENT_ATTRIBUTE_EACH),
  [METRIC_TYPE.APP_EVENT_UNIQUE]: Object.values(EVENT_ATTRIBUTE_UNIQUE),
  [METRIC_TYPE.APP_EVENT]: Object.values(EVENT_ATTRIBUTE), // in-app event所有子事件都有
  // [METRIC_TYPE.PAGE_EVENT]: [EVENT_ATTRIBUTE.EVENT_COUNT, EVENT_ATTRIBUTE.COST_PER_EVENT, EVENT_ATTRIBUTE.RATE_PER_EVENT], // page event只有3种子事件
  [METRIC_TYPE.PAGE_EVENT]: Object.values(EVENT_ATTRIBUTE), // page event所有子事件都有
  [METRIC_TYPE.SKAN_APP_EVENT]: Object.values(EVENT_ATTRIBUTE_SKAN),
  [METRIC_TYPE.ONSITE_EVENT]: Object.values(EVENT_ATTRIBUTE), // onsite event所有子事件都有
};

export const SORT_ORDER = {
  ACENT: 0, // 正序
  DECENT: 1, // 倒序
};
